// Import action types related to menu items
import {
  ITEMS_MENU_ARE_LOADING,
  ITEMS_MENU_FETCH_DATA_SUCCESS,
  ITEMS_MENU_HAVE_ERROR,
} from "../actionType";

// Define the initial state for the Menu reducer
const initialState = {
  data: [], // Initialize data as an empty array
  loading: true, // Set loading to true initially
  error: [], // Initialize error as an empty array
};

// Reducer function to handle menu-related actions and update state accordingly
export function MenuTabsReducer(state = initialState, action) {
  switch (action.type) {
    // Handle error case when fetching menu items
    case ITEMS_MENU_HAVE_ERROR:
      return {
        ...state,
        error: action.hasError, // Update the error state with the error from the action
        loading: false, // Set loading to false since the request is complete
      };

    // Handle loading state when menu items are being fetched
    case ITEMS_MENU_ARE_LOADING:
      return {
        ...state,
        loading: action.isLoading, // Update the loading state with the loading status from the action
      };

    // Handle success case when menu items are successfully fetched
    case ITEMS_MENU_FETCH_DATA_SUCCESS:
      return {
        ...state,
        data: action.menuTabs, // Update the data state with the fetched menu items
        loading: false, // Set loading to false since the request is complete
        error: [], // Clear any previous errors (assuming the success case means no error)
      };

    // Return the current state by default if action type is not recognized
    default:
      return state;
  }
}
